import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import { useMaterialUIController } from "context";

function DataTableBodyCell({ noBorder, align, children }) {
  const [controller] = useMaterialUIController();
  const { direction } = controller;
  return (
    <MDBox
      component="td"
      textAlign={
        direction === "rtl"
          ? align === "left"
            ? "right"
            : align === "right"
            ? "left"
            : align
          : align
      }
      py={1.5}
      px={3}
      sx={({ palette: { light }, typography: { size }, borders: { borderWidth } }) => ({
        fontSize: size.sm,
        borderBottom: noBorder ? "none" : `${borderWidth[1]} solid ${light.main}`,
      })}
    >
      <MDBox
        display="inline-block"
        width="max-content"
        color="text"
        sx={{ verticalAlign: "middle" }}
      >
        {children}
      </MDBox>
    </MDBox>
  );
}
DataTableBodyCell.defaultProps = {
  noBorder: false,
  align: "left",
};
DataTableBodyCell.propTypes = {
  children: PropTypes.node.isRequired,
  noBorder: PropTypes.bool,
  align: PropTypes.oneOf(["left", "right", "center"]),
};

export default DataTableBodyCell;
